import {colors} from '@prtimes-basis/styles/themes';

type Props = {
  readonly isActive: boolean;
};

export function FirstIcon({isActive}: Props) {
  const colors = getColors(isActive);

  return (
    <svg
      role='img'
      aria-label='1'
      width='31'
      height='30'
      viewBox='0 0 31 30'
      fill='none'
    >
      <circle
        cx='15.5'
        cy='15'
        r='14'
        fill='white'
        stroke={colors.circle}
        strokeWidth='2'
      />
      <path
        d='M16.7969 21H14.6016V12.7266C13.7995 13.4766 12.8542 14.0312 11.7656 14.3906V12.3984C12.3385 12.2109 12.9609 11.8568 13.6328 11.3359C14.3047 10.8099 14.7656 10.1979 15.0156 9.5H16.7969V21Z'
        fill={colors.number}
      />
    </svg>
  );
}

export function SecondIcon({isActive}: Props) {
  const colors = getColors(isActive);

  return (
    <svg
      role='img'
      aria-label='2'
      width='31'
      height='30'
      viewBox='0 0 31 30'
      fill='none'
    >
      <circle
        cx='15.5'
        cy='15'
        r='14'
        fill='white'
        stroke={colors.circle}
        strokeWidth='2'
      />
      <path
        d='M18.5938 18.9609V21H10.8984C10.9818 20.2292 11.2318 19.5 11.6484 18.8125C12.0651 18.1198 12.888 17.2031 14.1172 16.0625C15.1068 15.1406 15.7135 14.5156 15.9375 14.1875C16.2396 13.7344 16.3906 13.2865 16.3906 12.8438C16.3906 12.3542 16.2578 11.9792 15.9922 11.7188C15.7318 11.4531 15.3698 11.3203 14.9062 11.3203C14.4479 11.3203 14.0833 11.4583 13.8125 11.7344C13.5417 12.0104 13.3854 12.4688 13.3438 13.1094L11.1562 12.8906C11.2865 11.6823 11.6953 10.8151 12.3828 10.2891C13.0703 9.76302 13.9297 9.5 14.9609 9.5C16.0911 9.5 16.9792 9.80469 17.625 10.4141C18.2708 11.0234 18.5938 11.7812 18.5938 12.6875C18.5938 13.2031 18.5 13.6953 18.3125 14.1641C18.1302 14.6276 17.8385 15.1146 17.4375 15.625C17.1719 15.9635 16.6927 16.4505 16 17.0859C15.3073 17.7214 14.8672 18.1432 14.6797 18.3516C14.4974 18.5599 14.349 18.763 14.2344 18.9609H18.5938Z'
        fill={colors.number}
      />
    </svg>
  );
}

export function ThirdIcon({isActive}: Props) {
  const colors = getColors(isActive);

  return (
    <svg
      role='img'
      aria-label='3'
      width='31'
      height='30'
      viewBox='0 0 31 30'
      fill='none'
    >
      <circle
        cx='15.5'
        cy='15'
        r='14'
        fill='white'
        stroke={colors.circle}
        strokeWidth='2'
      />
      <path
        d='M11.1016 17.9609L13.2266 17.7031C13.2943 18.2448 13.4766 18.6589 13.7734 18.9453C14.0703 19.2318 14.4297 19.375 14.8516 19.375C15.3047 19.375 15.6849 19.2031 15.9922 18.8594C16.3047 18.5156 16.4609 18.0521 16.4609 17.4688C16.4609 16.9167 16.3125 16.4792 16.0156 16.1562C15.7188 15.8333 15.3568 15.6719 14.9297 15.6719C14.6484 15.6719 14.3125 15.7266 13.9219 15.8359L14.1641 14.0469C14.7578 14.0625 15.2109 13.9349 15.5234 13.6641C15.8359 13.388 15.9922 13.0234 15.9922 12.5703C15.9922 12.1849 15.8776 11.8776 15.6484 11.6484C15.4193 11.4193 15.1146 11.3047 14.7344 11.3047C14.3594 11.3047 14.0391 11.4349 13.7734 11.6953C13.5078 11.9557 13.3464 12.3359 13.2891 12.8359L11.2656 12.4922C11.4062 11.7995 11.6172 11.2474 11.8984 10.8359C12.1849 10.4193 12.5807 10.0938 13.0859 9.85938C13.5964 9.61979 14.1667 9.5 14.7969 9.5C15.875 9.5 16.7396 9.84375 17.3906 10.5312C17.9271 11.0938 18.1953 11.7292 18.1953 12.4375C18.1953 13.4427 17.6458 14.2448 16.5469 14.8438C17.2031 14.9844 17.7266 15.2995 18.1172 15.7891C18.513 16.2786 18.7109 16.8698 18.7109 17.5625C18.7109 18.5677 18.3438 19.4245 17.6094 20.1328C16.875 20.8411 15.9609 21.1953 14.8672 21.1953C13.8307 21.1953 12.9714 20.8984 12.2891 20.3047C11.6068 19.7057 11.2109 18.9245 11.1016 17.9609Z'
        fill={colors.number}
      />
    </svg>
  );
}

function getColors(isActive: boolean) {
  return isActive
    ? {
        circle: colors.primaryBlue[800],
        number: colors.primaryBlue[800],
      }
    : {
        circle: colors.grays[300],
        number: colors.grays[400],
      };
}
